import dayjs from "dayjs"
import { ReactComponent as WARNING } from "../../../../assets/WarningICON.svg"
import { returnAddressString, returnThousanderBreakInNumber, returnTotalNettoAmount } from "../../../../services/functions"
import BaseTableRow from "../../../../components/layout/BaseTableRow"
import { Tag } from "antd"
import { MajorOrderState } from "../../../../api/constants"
import { BillGet } from "../../../../data/Types"
import { useNavigate } from "react-router-dom"
import { P } from "../../../../auth/permissions"
import { Authorized } from "../../../../components/authentication/Authorized"
import { useAbility } from "../../../../components/contexts/AbilityContext"

type BillTemplateTableRowType = {
    id: string
    createdAt: Date
    customer: {
        name: string
        softDeleteAfter?: Date
    }
    object: any // TODO
    amount: number
    bills: BillGet[]
    description: string
    state: string
    archived: boolean
}

export default function MajorOrderTableRow(props: BillTemplateTableRowType) {
    const navigate = useNavigate()
    const ability = useAbility()

    const handleClickOnRow = () => {
        if (ability.can(P.buchhaltung_read.action, P.buchhaltung_read.subject)) {
            navigate("/buchhaltung/aufträge/" + props.id)
        }
    }
    return (
        <BaseTableRow onClick={handleClickOnRow} classProps={`${props.archived && "opacity-40 bg-gray-100"} `}>
            <td className="table-cell">
                <p className="line-clamp-1 text-center">{dayjs(props.createdAt).format("DD.MM.YYYY")}</p>
            </td>
            <td className="table-cell">
                <p title={props.customer.name} className="line-clamp-1 flex justify-center text-center">
                    {props.customer.softDeleteAfter && (
                        <span className="pr-2">
                            <WARNING className="w-6 h-6 text-red-700" />
                        </span>
                    )}
                    {props.customer.name}
                </p>
            </td>
            <td className="hidden xl:table-cell">
                <p title={returnAddressString(props.object)} className="line-clamp-1 flex justify-center text-center">
                    {props.object.softDeleteAfter && (
                        <span className="pr-2">
                            <WARNING className="w-6 h-6 text-red-700" />
                        </span>
                    )}
                    {props.object?.adress ? returnAddressString(props.object) : "keine Angabe"}
                </p>
            </td>
            <Authorized allOf={[P.buchhaltung_read]}>
                <td>
                    <p className="line-clamp-1  text-center">{returnThousanderBreakInNumber(props.amount)} €</p>
                </td>
                <td className="hidden lg:table-cell">
                    <p className="line-clamp-1 text-center">{returnThousanderBreakInNumber(returnTotalNettoAmount(props.bills))} €</p>
                </td>
            </Authorized>
            <td className="hidden xl:table-cell">
                <p className="line-clamp-1 text-center">{props.description}</p>
            </td>
            <td className="hidden md:table-cell">
                <p className="line-clamp-1 text-center">{props.bills.length}</p>
            </td>
            <td className="table-cell">
                <div className="flex w-full justify-center">
                    <Tag
                        color={
                            props.state === MajorOrderState.FULLY_BILLED
                                ? "green"
                                : props.state === MajorOrderState.PARTIALLY_BILLED
                                ? "blue"
                                : "gray"
                        }>
                        {props.state === MajorOrderState.FULLY_BILLED
                            ? "Abgeschlossen"
                            : props.state === MajorOrderState.UNBILLED
                            ? "Noch Nichts Berechnet"
                            : "Teilweise Berechnet"}
                    </Tag>
                </div>
            </td>
        </BaseTableRow>
    )
}
